var map = {
	"./LoFi.png": 2871,
	"./buonipropositi.png": 5898,
	"./buonumore.png": 9546,
	"./chilly-christmas.png": 8535,
	"./coraggio.png": 5074,
	"./crush.png": 5732,
	"./doccia.png": 8751,
	"./dose.png": 4363,
	"./energia.png": 4338,
	"./grandimai.png": 7025,
	"./lacrime.png": 5971,
	"./lui-lei.png": 7993,
	"./relax.png": 7913,
	"./restart.png": 7296,
	"./speciale.png": 2402,
	"./tiamo.png": 4863,
	"./tristi.png": 2408,
	"./tvb.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8561;